import React from "react";
import { navigate } from "@reach/router";
import { Flex, Heading } from "@pacerpro/shared-ui";

const Unauthorized = () => {
  React.useEffect(() => {
    const timeout = setTimeout(() => {
      navigate("/mycases");
    }, 250);
    return () => clearTimeout(timeout);
  }, []);
  return (
    <Flex justify="center" p={4}>
      <Heading as="h5">
        You are not authorized to access this content. Navigating you back to
        your cases.
      </Heading>
    </Flex>
  );
};

export default Unauthorized;
